import * as React from 'react';

import { cn } from '@/lib/utils';
import type { ValidationState } from '@/theme/size-tokens';
import {
  validationBorderClasses,
  validationRingClasses,
} from '@/theme/size-tokens';

type InputProps = React.ComponentProps<'input'> & {
  validationState?: ValidationState;
};

function Input({
  className,
  type,
  validationState = 'neutral',
  ...props
}: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      aria-invalid={validationState === 'error'}
      className={cn(
        'bg-transparent text-foreground placeholder:text-muted-foreground flex h-10 w-full rounded-lg border px-4 py-2 text-base shadow-md transition-all duration-200 outline-none focus:ring-2 focus:ring-offset-0 focus:shadow-lg disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted/50 sm:h-9 sm:px-3 sm:text-sm',
        validationBorderClasses[validationState],
        validationRingClasses[validationState],
        className
      )}
      {...props}
    />
  );
}

export { Input };
export type { InputProps };
